import React from 'react';
import {observer} from 'mobx-react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {BenefitDivisionList, BenefitDivisionForm} from './divisions';
import {TaxableBenefitFlow} from './configuration';

const TaxableBenefitsPage = observer(() => {
  return (
    <Router basename='/taxable_benefits'>
      <Switch>
        <Route exact path='/' component={BenefitDivisionList} />
        <Route path='/benefit_divisions/:benefitDivisionId' component={BenefitDivisionForm} />
        <Route path='/:id/rates' component={TaxableBenefitFlow} />
        <Route path='/:id/rates/:groupBenefitCoverageId' component={TaxableBenefitFlow} />
      </Switch>
    </Router>
  );
});

export default TaxableBenefitsPage;
